declare global {
  interface Window {
    $zoho?: {
      salesiq?: {
        floatbutton?: {
          visible?: (state: "show" | "hide") => void;
        };
        floatwindow?: {
          visible?: (state: "show" | "hide") => void;
        };
      };
    };
  }
}

/**
 * TODO: Move this outside of `/design`
 */
const useZohodeskChatbox = () => {
  function show() {
    if (window.$zoho?.salesiq?.floatwindow) {
      window.$zoho.salesiq.floatwindow.visible?.("show");
      return;
    }
    // Fallback for legacy widget
    (document.querySelector('[data-zsqa]') as HTMLButtonElement)?.click();
  }

  return { show };
};

export default useZohodeskChatbox;
